import React from "react";
import "./NodAbout.styles.scss";

const NodAboutComponent = () => {
  return (
    <div className="nod-about-page-first-section">
      <h4 className="nod-about-heading">About NOD Bearings</h4>
      <p className="nod-about-text">
        Our Journey in the bearings business started back in 1969 in Mumbai.
        Since then we have continued to expand our activities from manufacturing
        bearings in India to becoming a global bearings distribution and
        solutions provider.
      </p>
      <p className="nod-about-text">
        We at NOD Bearings Pvt Ltd believe in creating long-term mutually
        beneficial relationships with all customers, suppliers, vendors,
        institutions & employees, who we call our partners. We strongly believe
        in the mantra that if our partners grow then only we can grow. Our aim
        is always to safeguard and protect the interest of all those associated
        with us. This has been and will continue to be the pillar of our
        success.
      </p>
      <p className="nod-about-text">
        Our view is to be a global entity and embrace the spirit of localization
        by working across international boundaries and investing in long-term
        mutually beneficial relationships with our partners. We welcome you to
        be a part of our success.
      </p>
    </div>
  );
};

export default NodAboutComponent;
